import React, { useCallback } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import { LinkContainer } from "components/common";
import { DropdownButton, MenuItem } from "components/bootstrap";
import { SIGMA_ENTITY_CREATORS } from "./index";
const useEntityCreators = (entityKeys) => {
  const entityCreators = usePluginEntities("entityCreators");
  const { permissions } = useCurrentUser();
  return entityCreators.filter(
    (creator) => entityKeys.includes(creator.id) && isPermitted(permissions, creator.permissions)
  );
};
function SigmaEventDefinitionsOptions({ disabled = false }) {
  const entityCreators = useEntityCreators(Object.values(SIGMA_ENTITY_CREATORS));
  const sendTelemetry = useSendTelemetry();
  const _menuItemOnClick = useCallback(
    (creator) => () => {
      const { telemetryEvent } = creator;
      if (telemetryEvent) {
        sendTelemetry(telemetryEvent.type, {
          app_section: telemetryEvent.section,
          app_action_value: telemetryEvent.actionValue
        });
      }
    },
    [sendTelemetry]
  );
  if (entityCreators.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      bsSize: "md",
      bsStyle: "primary",
      title: "",
      pullRight: true,
      id: "sigma-entity-creators-dropdown",
      disabled
    },
    entityCreators.map((creator) => /* @__PURE__ */ React.createElement(LinkContainer, { key: creator.id, to: creator.path }, /* @__PURE__ */ React.createElement(MenuItem, { onClick: _menuItemOnClick(creator) }, creator.title)))
  );
}
export default SigmaEventDefinitionsOptions;
